import { createRoute, lazyRouteComponent } from "@tanstack/react-router"
import { webappRoute } from "./layout"

export const settingsRoute = createRoute({
  getParentRoute: () => webappRoute,
  path: "/settings",
  component: lazyRouteComponent(() => import("./lazy-pages"), "SettingsPage"),
})
